import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { RecommendationFileType } from "../types";
import { useLang } from "../LanguageContextProvider";
import { renderDeadline } from "../recommendationDeadline";

const RecommendationFootnotes: React.FC<{
  fileType: RecommendationFileType;
}> = ({ fileType }) => {
  const { lang } = useLang();

  return (
    <Stack>
      <Typography variant="body2">
        {lang === "en"
          ? "Each document is to be uploaded in PDF format. Make sure your file name ends with \".pdf\". Please do not encrypt/lock your PDF file. (Everything is encrypted at transit and at rest by default.)"
          : "PDF形式にてアップロードしてください。ファイル名が.pdfで終わらない場合、エラーが起きる可能性があります。PDFファイルには鍵をかけないでください。（通信とストレージがすべて暗号化されたセキュアな環境に保存されます。）"}
      </Typography>
      {fileType === "report" ? (
        <Typography variant="body2">
          {lang === "en"
            ? "Please use the same school report format that you use for college admission."
            : "日本の大学受験時に用いられるものと同様の書式を用いてください。"}
        </Typography>
      ) : null}
      {fileType === "report" ? (
        <Typography variant="body2">
          {lang === "en"
            ? "If you are unable to submit a school report, please upload an official transcript with notes regarding class rank and extracurricular activities."
            : "ただし、海外現地校の所属または卒業などの理由で調査書が提出できない場合は、高等学校発行の正式な成績表(Transcriptなど) に、カウンセラーによる学年での順位と課外活動についてのコメントを添え、一つの書類にまとめて提出してください。"}
        </Typography>
      ) : null}
      {fileType === "report" ? null : (
        <Typography variant="body2">
          {lang === "en" ? "You can write the letter in either English or Japanese." : "記述は、日本語でも英語でも構いません。"}
        </Typography>
      )}
      {fileType === "report" ? null : (
        <Typography variant="body2">
          {lang === "en"
            ? "We need one letter from each category. (The last category only applies to students who studied abroad for more than one semester.)"
            : "1, 2のカテゴリーからそれぞれ１通が必要です。(最後は高校在学中に一学期以上留学されていた方のみ現地校の調査書が必要です。)"}
        </Typography>
      )}
      {fileType === "report" ? null : (
        <Typography variant="body2">
          {lang === "en"
            ? "・Rec Letter 1: Homeroom teacher or counselor"
            : "・推薦状１: 担任教員またはカウンセラー"}
        </Typography>
      )}
      {fileType === "report" ? null : (
        <Typography variant="body2">
          {lang === "en"
            ? "・Rec Letter 2: Individual who knows the applicant well, except family or peers"
            : "・推薦状２: 応募者をよく知る人物（親族や同世代の友人を除く）"}
        </Typography>
      )}
      {fileType === "report" ? null : (
        <Typography variant="body2">
          {lang === "en"
            ? "・Transcript while abroad: Transcript from school where the applicant attended during study abroad."
            : "・留学中の調査書: 留学先の学校からの調査書"}
        </Typography>
      )}
      <Typography variant="body2">
        {lang === "en" ? `The deadline is ${renderDeadline(lang)}.` : `締切は、${renderDeadline(lang)}です。`}
      </Typography>
    </Stack>
  );
};

export default RecommendationFootnotes;
